<script lang="ts">
  import { Globe } from "lucide-svelte";

  export interface CountryItem {
    code: string;  // 二字 ISO 代码，如 "CN", "US"
    name: string;  // 显示名称
    pv: number;
    percentage: number;
  }

  interface Props {
    countries?: CountryItem[];
    t: (key: string, params?: Record<string, any>) => string;
  }

  let { countries = [], t }: Props = $props();

  // 将 ISO 国家二字码（如 CN, US）转为 Emoji 国旗
  function getFlagEmoji(countryCode: string) {
    if (!countryCode || countryCode.length !== 2) return "🌐";
    const codePoints = countryCode
      .toUpperCase()
      .split('')
      .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  }
</script>

<div class="rounded-xl border bg-card p-5 shadow-sm flex flex-col justify-between">
  <div>
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div>
        <h3 class="text-sm font-semibold">{t('dashboard.charts.top_countries_title') || '访客国家/地区分布'}</h3>
        <p class="text-xs text-muted-foreground">{t('dashboard.charts.top_countries_desc') || '近30天全站访客的地理位置来源 Top 5'}</p>
      </div>
      <div class="p-2 bg-primary/10 rounded-lg text-primary">
        <Globe class="size-4" />
      </div>
    </div>

    <!-- Content List -->
    {#if countries && countries.length > 0}
      <div class="space-y-3 mt-3">
        {#each countries as item, index}
          <div class="p-2.5 rounded-lg border bg-muted/20 hover:bg-muted/50 transition-colors">
            <div class="flex items-center justify-between gap-2 mb-1.5">
              <div class="flex items-center gap-2 overflow-hidden">
                <span class="text-base shrink-0 leading-none" role="img" aria-label={item.name}>
                  {getFlagEmoji(item.code)}
                </span>
                <span class="text-xs font-medium truncate">{item.name}</span>
                <span class="text-[10px] text-muted-foreground font-mono">({item.code})</span>
              </div>
              <div class="flex items-center gap-3 text-xs shrink-0">
                <span class="font-bold">{item.pv.toLocaleString()} <span class="text-[10px] font-normal text-muted-foreground">PV</span></span>
                <span class="w-10 text-right text-[11px] bg-muted px-1 py-0.5 rounded font-mono">{item.percentage}%</span>
              </div>
            </div>

            <!-- Progress Bar -->
            <div class="w-full bg-muted rounded-full h-1.5 overflow-hidden">
              <div 
                class="bg-emerald-500 h-1.5 rounded-full transition-all duration-500" 
                style="width: {Math.min(100, Math.max(0, item.percentage))}%"
              ></div>
            </div>
          </div>
        {/each}
      </div>
    {:else}
      <div class="flex h-48 items-center justify-center text-xs text-muted-foreground">
        {t('dashboard.charts.no_countries_data') || '暂无国家/地区访问数据'}
      </div>
    {/if}
  </div>
</div>